import { LoadIndicator, TagBox } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Alert, Button, Card, CardBody, Col, Row } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import api from '../../../services/api-configuration';
import { getAllWarehouses } from '../../../services/apis';
const PlatformDashboard = () => {
    const [selectedWarehouses, setSelectedWarehouses] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const wh = await getAllWarehouses();
                setWarehouses(wh);
            } catch (error) {
                console.log(error);
            }
        };
        fetchWarehouses();
    }, []);

    const fetchPlatformData = async () => {
        if (!selectedWarehouses.length) {
            toast.error('Depo seçiniz');
            return;
        }

        setLoading(true);
        try {
            const response = await api.post('/getPeronAddressesWithOccupancy', {
                warehouse_ids: selectedWarehouses
            });

            if (response.data.success) {
                if (response.data.data === null) {
                    toast.error('Peron verisi bulunamadı');
                    return;
                }
                const validPlatforms = response.data.data.filter(p => p.address_code);
                setPlatforms(validPlatforms);
            }
        } catch (error) {
            let message = error.response?.data?.error || "";
            toast.error('Peron verisi alınamadı' + " " + message);
            console.error('Error fetching platform data:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'EMPTY':
                return '#00a152';  // green
            case 'PARTIALLY_FULL':
                return '#ff9800';  // orange
            case 'FULL':
                return '#f4511e';  // red
            default:
                return '#gray';
        }
    };

    const PlatformCard = ({ platform }) => {
        const totalReservedVehicles = platform.groupages.reduce((sum, group) =>
            sum + group.reserved_vehicles, 0);
        const totalVehiclesInPeron = platform.groupages.reduce((sum, group) =>
            sum + group.vehicles_in_peron, 0);
        const totalVehiclesInExit = platform.groupages.reduce((sum, group) =>
            sum + group.vehicles_in_exit, 0);

        const isEmpty = totalVehiclesInPeron === 0 && totalVehiclesInExit === 0 && totalReservedVehicles === 0;

        return (
            <Card style={{
                minHeight: '160px',
                height: 'max-content',
                backgroundColor: platform.groupages?.length === 0 ? '#ffaf1d' : (totalReservedVehicles === 0) ? "#00a152" : "#ff5050",
                margin: '0px',
                padding: '0px',
            }}>
                <CardBody className="text-white p-2">
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr" }}>
                        <h3 style={{ fontSize: '30px', margin: 0, fontWeight: 'bold' }}>{platform?.address_code}
                            <small
                                style={{ fontSize: '14px' }}
                            >
                                ({platform?.capacity})
                            </small>

                        </h3>
                        <div className="text-end" style={{ minWidth: '110px' }}>
                            <div style={{
                                fontSize: '12px',
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                            }}>
                                <span>Planlanan Araç Sayısı <b> {totalVehiclesInPeron + totalVehiclesInExit + totalReservedVehicles} </b></span>
                                <span>
                                    {platform?.warehouse_name}
                                </span>
                            </div>
                            <div style={{
                                fontSize: '12px', lineHeight: '1.5', display: 'flex', flexWrap: 'wrap',
                                alignItems: 'flex-end'
                            }}>
                                {Array(totalVehiclesInPeron)
                                    .fill(null)
                                    .map((_, idx) => (
                                        <i
                                            key={`peron-${idx}`}
                                            className="fa fa-check-square-o"
                                            aria-hidden="true"
                                            style={{
                                                fontSize: '14px',
                                                marginRight: '1px',

                                            }}
                                        ></i>
                                    ))}

                                {Array(totalReservedVehicles)
                                    .fill(null)
                                    .map((_, idx) => (
                                        <span
                                            key={`reserved-${idx}`}
                                            aria-hidden="true"
                                            style={{
                                                fontSize: '14px',
                                                marginRight: '1px',
                                            }}
                                        >
                                            ⏸
                                        </span>
                                    ))}
                            </div>

                        </div>
                    </div>

                    {loading ? (
                        <div className="d-flex justify-content-center mt-3">
                            <LoadIndicator height={30} width={30} />
                        </div>
                    ) : (
                        <table className="table table-sm table-borderless mt-3" id='peron-reports-table'>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td className='p-0 text-white'>Hazır</td>
                                    <td className='p-0 text-white'>{totalVehiclesInPeron}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className='p-0 text-white'>Çekilecek</td>
                                    <td className='p-0 text-white'>{totalReservedVehicles}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className='p-0 text-white'>Grupaj Adet</td>
                                    <td className='p-0 text-white'>  {platform?.groupages.length} </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className='p-0 text-center' colSpan="2">-</td>
                                </tr>
                                {
                                    isEmpty
                                        ? (
                                            <tr>
                                                <td className='p-0 text-center' colSpan="2">Boş</td>
                                            </tr>
                                        ) : (
                                            platform?.groupages.map(group => (
                                                <tr key={group.groupageNo}>
                                                    <td className='p-0 text-white'>{group.plate_number}</td>
                                                    <td className='p-0 text-white'>{group.groupageNo}</td>
                                                    <td className='p-0 text-white'>{group.route}</td>
                                                    <td className='p-0 text-white'
                                                        style={{ fontWeight: 'bold' }} >({group.reserved_vehicles + group.vehicles_in_peron + group.vehicles_in_exit})
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                            </tbody>
                        </table>
                    )}
                </CardBody>
            </Card>

        );
    };

    return (
        <>
            <Breadcrumb current="Peron Takip" />
            <div className="p-3">
                <div className="mb-3 d-flex align-items-center bg-white p-3 rounded">
                    <div className="me-2" style={{ minWidth: '100px' }}>Depo</div>
                    <TagBox
                        style={{ width: '100%' }}
                        dataSource={warehouses}
                        displayExpr="warehouse_name"
                        valueExpr="id"
                        showClearButton={true}
                        placeholder="Depo Seçiniz"
                        className='me-2 mr-2'
                        value={selectedWarehouses}
                        onValueChanged={(e) => setSelectedWarehouses(e.value)}
                    />
                    <Button
                        color="success"
                        className="px-4"
                        onClick={fetchPlatformData}
                        disabled={loading}
                    >
                        {loading ? (
                            <LoadIndicator width={16} height={16} />
                        ) : (
                            'Listele'
                        )}
                    </Button>
                </div>
                <Row className='w-100'>
                    {
                        loading ?
                            <>
                                <Alert color="info" className="w-75 mx-auto text-center"> Yükleniyor...</Alert>
                            </>
                            :
                            <>
                                {platforms.map(platform => (
                                    <Col key={platform?.address_code}
                                        xxl={3}
                                        xl={4}
                                        md={6}
                                        xs={12}
                                        className='p-1 m-0'>
                                        <PlatformCard platform={platform} />
                                    </Col>
                                ))}
                            </>
                    }

                </Row>
            </div>
        </>
    );
};

export default PlatformDashboard;